import {API_URL} from '../../../../resources/api';

export const winLosesURL : string = `${API_URL}dashboard/managers/winloses`;
export const rankURL : string = `${API_URL}dashboard/managers/rank`;
export const resumeURL : string = `${API_URL}dashboard/managers/resume`;